(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* announce rotator */
  var msgs = $$('.amsg'), ai = 0, timer;
  function show(n) {
    ai = (n + msgs.length) % msgs.length;
    msgs.forEach(function (m, i) {
      m.classList.toggle('on', i === ai);
      m.setAttribute('aria-hidden', i === ai ? 'false' : 'true');
    });
  }
  function arm() { clearInterval(timer); timer = setInterval(function () { show(ai + 1); }, 5000); }
  if (msgs.length > 1) {
    $$('.anav').forEach(function (b) {
      b.addEventListener('click', function () { show(ai + (+b.dataset.astep)); arm(); });
    });
    arm();
  }

  /* burger */
  var mb = $('.menubtn'), mn = $('.mnav');
  if (mb && mn) {
    mb.addEventListener('click', function () {
      var on = mn.classList.toggle('on');
      mb.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  /* mobile nav accordions */
  $$('.mdrop-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.closest('.mhas-drop').querySelector('.mdrop');
      var open = panel.hidden;
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* accordions (FAQ + product) */
  $$('.fq .q').forEach(function (b) {
    b.addEventListener('click', function () {
      var open = b.parentNode.classList.toggle('open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  /* home: featured tabs */
  $$('.tabs [data-tab]').forEach(function (t, _, tabs) {
    t.addEventListener('click', function () {
      tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      $$('[data-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== t.dataset.tab; });
    });
  });

  /* shop the look hotspots */
  $$('.hot').forEach(function (h, _, hots) {
    h.addEventListener('click', function () {
      hots.forEach(function (x) { x.setAttribute('aria-pressed', x === h ? 'true' : 'false'); });
      $$('.lslot').forEach(function (s) { s.hidden = s.getAttribute('data-slot') !== h.dataset.hot; });
    });
  });

  /* why-us tabs */
  var wt = $('[data-wtabs]');
  if (wt) {
    wt.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      $$('button', wt).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      $$('[data-wp]').forEach(function (p) { p.hidden = p.dataset.wp !== b.dataset.wt; });
    });
  }

  /* header cart count */
  function setCartCount(n) {
    var link = $('.hdr .hic a[href*="/cart"]');
    if (!link) return;
    var dot = $('.dot', link);
    if (n > 0) {
      if (!dot) { dot = document.createElement('span'); dot.className = 'dot'; link.appendChild(dot); }
      dot.textContent = n;
    } else if (dot) dot.remove();
    link.setAttribute('aria-label', 'Cart, ' + n + ' items');
  }

  function postJson(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (j) { throw j; });
      return r.json();
    });
  }

  /* quick add (Complete the look) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b || b.disabled) return;
    b.disabled = true;
    postJson('/cart/add.js', { id: +b.dataset.quickAdd, quantity: 1 })
      .then(function () { b.textContent = 'Added ✓'; b.classList.add('done'); return afterCartChange(); })
      .then(function () { drawerSet(true); })
      .catch(function () { b.disabled = false; });
  });

  /* reveal helper for fetched fragments */
  function revealNow(root) {
    $$('.rv', root).forEach(function (el) { el.classList.add('in'); });
  }

  /* product: gallery, hero stage + filmstrip */
  var stage = $('[data-stage]');
  if (stage) {
    var shots = $$('img', stage),
        stripEl = $('[data-strip]'),
        thumbs = stripEl ? $$('button', stripEl) : [],
        idxEl = $('[data-stage-idx]'),
        cur = 0;
    var gshow = function (i) {
      if (!shots.length) return;
      cur = (i + shots.length) % shots.length;
      shots.forEach(function (s, j) { s.classList.toggle('on', j === cur); });
      thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === cur ? 'true' : 'false'); });
      if (idxEl) idxEl.textContent = cur + 1;
    };
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { gshow(i); }); });
    if (!reduced && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect(),
            x = (e.clientX - r.left) / r.width * 100,
            y = (e.clientY - r.top) / r.height * 100;
        shots[cur].style.transformOrigin = x + '% ' + y + '%';
        shots[cur].style.transform = 'scale(1.7)';
      });
      stage.addEventListener('mouseleave', function () {
        shots.forEach(function (s) { s.style.transform = ''; s.style.transformOrigin = ''; });
      });
    }
    var tx = null;
    stage.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx;
      tx = null;
      if (Math.abs(dx) > 40) gshow(cur + (dx < 0 ? 1 : -1));
    }, { passive: true });

    var lb = $('[data-lb]');
    if (lb) {
      var lbImg = $('img', lb);
      var lbClose = function () { lb.classList.remove('on'); lb.setAttribute('aria-hidden', 'true'); };
      stage.addEventListener('click', function () {
        lbImg.src = shots[cur].currentSrc || shots[cur].src;
        lbImg.alt = shots[cur].alt || 'Enlarged product photo';
        lb.classList.add('on');
        lb.setAttribute('aria-hidden', 'false');
      });
      $('[data-lb-close]', lb).addEventListener('click', lbClose);
      lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') lbClose();
        if (document.activeElement && /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName)) return;
        if (e.key === 'ArrowRight') gshow(cur + 1);
        if (e.key === 'ArrowLeft') gshow(cur - 1);
      });
    }
  }

  /* product: variant picker (radio fieldsets -> hidden variant id) */
  var picker = $('[data-variant-picker]');
  if (picker) {
    var variants = JSON.parse(picker.querySelector('[data-variants]').textContent);
    var stockMap = {};
    var stockNode = picker.querySelector('[data-stock]');
    if (stockNode) { try { stockMap = JSON.parse(stockNode.textContent); } catch (err) { stockMap = {}; } }
    var preorderMap = {};
    var poNode = picker.querySelector('[data-preorder]');
    if (poNode) { try { preorderMap = JSON.parse(poNode.textContent); } catch (err) { preorderMap = {}; } }
    var idInput = $('form[data-product-form] input[name="id"]');
    var fsets = $$('fieldset', picker);
    function currentOptions() {
      return fsets.map(function (f) {
        var c = $('input:checked', f); return c ? c.value : null;
      });
    }
    function match() {
      var opts = currentOptions();
      var v = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
      /* current value labels */
      fsets.forEach(function (f) {
        var c = $('input:checked', f), em = $('[data-optval]', f);
        if (c && em) em.textContent = c.value;
      });
      /* size availability crossing */
      var szf = $('[data-size-fieldset]', picker);
      if (szf) {
        var szIdx = +szf.dataset.optindex;
        $$('label', szf).forEach(function (lab) {
          var val = $('input', lab).value;
          var ok = variants.some(function (vv) {
            return vv.available && vv.options.every(function (o, i) { return i === szIdx ? o === val : o === opts[i]; });
          });
          lab.classList.toggle('out', !ok);
        });
      }
      if (!v) return;
      idInput.value = v.id;
      var vUrl = new URL(window.location);
      vUrl.searchParams.set('variant', v.id);
      history.replaceState({}, '', vUrl);
      var priceEl = $('[data-price]'), btn = $('[data-atc-text]'), amt = $('[data-atc-amount]');
      if (priceEl) priceEl.textContent = money(v.price);
      if (amt) amt.textContent = '· ' + money(v.price);
      var md = $('[data-markdown]'), wasEl = $('[data-compare]'), saveEl = $('[data-save]');
      if (md) {
        if (v.compare_at_price > v.price) {
          if (wasEl) wasEl.textContent = money(v.compare_at_price);
          if (saveEl) saveEl.textContent = 'Save $' + Math.round((v.compare_at_price - v.price) / 100) + ' · ' + Math.floor((1 - v.price / v.compare_at_price) * 100) + '%';
          md.hidden = false;
        } else md.hidden = true;
      }
      var bn = $('[data-bnpl]');
      if (bn) bn.textContent = money(Math.round(v.price / 4));
      if (btn) btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
      var submit = $('form[data-product-form] [type="submit"]');
      if (submit) submit.disabled = !v.available;
      /* sticky bar */
      var bp = $('[data-bar-price]'), bw = $('[data-bar-was]'), bb = $('[data-bar-btn]'), bs = $('[data-bar-sub]');
      if (bp) bp.textContent = money(v.price);
      if (bw) {
        if (v.compare_at_price > v.price) { bw.textContent = money(v.compare_at_price); bw.hidden = false; }
        else bw.hidden = true;
      }
      if (bb) { bb.disabled = !v.available; bb.textContent = v.available ? bb.dataset.add : bb.dataset.soldout; }
      if (bs) {
        bs.textContent = fsets.map(function (f) {
          var c = $('input:checked', f);
          return (f.hasAttribute('data-size-fieldset') ? 'Size ' : '') + (c ? c.value : '');
        }).join(' · ');
      }
      /* size-linked scarcity */
      var sl = $('[data-stockline]'), st = $('[data-stock-txt]');
      if (sl && st) {
        var rec = stockMap[v.id];
        if (rec && rec.m && rec.a && rec.q > 0 && rec.q <= 4) {
          var szf2 = $('[data-size-fieldset]', picker);
          var szv = szf2 ? ($('input:checked', szf2) || {}).value : null;
          st.textContent = 'Only ' + rec.q + ' left' + (szv ? ' in size ' + szv : '');
          sl.hidden = false;
        } else sl.hidden = true;
      }
      var bisEl = $('[data-bis]');
      if (bisEl) bisEl.hidden = v.available;
      var poRec = preorderMap[v.id];
      var isPo = poRec && poRec.po;
      var etaNorm = $('[data-eta-normal]');
      var etaPo = $('[data-eta-preorder]');
      var etaDl = $('[data-eta-deadline]');
      if (etaNorm) etaNorm.hidden = !!isPo;
      if (etaPo) {
        etaPo.hidden = !isPo;
        if (isPo) { var poB = $('[data-eta-po]', etaPo); if (poB) poB.textContent = poRec.d || ''; }
      }
      if (etaDl) etaDl.hidden = !!isPo;
    }
    picker.addEventListener('change', match);
    match();
  }

  /* back-in-stock notification */
  var bisSL = $('[data-bis-sendlane]');
  if (bisSL) {
    bisSL.addEventListener('click', function () {
      if (window._Sendlane && _Sendlane.openForm) {
        _Sendlane.openForm(bisSL.dataset.bisSendlane);
      }
    });
    window.addEventListener('sendlaneForms', function (e) {
      if (e.detail && e.detail.type === 'submit') {
        var ok = $('[data-bis-ok]');
        if (ok) ok.hidden = false;
        bisSL.hidden = true;
      }
    });
  } else {
    var bisForm = $('[data-bis-form]');
    if (bisForm) {
      bisForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = $('[data-bis-email]', bisForm).value.trim();
        if (!email) return;
        var sel = picker ? ($('input:checked', picker) || {}).value : '';
        var body = 'Back-in-stock request\n'
          + 'Product: ' + bisForm.dataset.product + '\n'
          + 'Variant: ' + sel + '\n'
          + 'URL: ' + window.location.origin + bisForm.dataset.url + '\n'
          + 'Email: ' + email;
        var fd = new FormData();
        fd.append('form_type', 'contact');
        fd.append('utf8', '✓');
        fd.append('contact[email]', email);
        fd.append('contact[body]', body);
        fd.append('contact[tags]', 'back-in-stock,' + bisForm.dataset.handle);
        var goBtn = $('[data-bis-form] .bis-go');
        if (goBtn) { goBtn.disabled = true; goBtn.textContent = 'Sending…'; }
        fetch('/contact#contact_form', {
          method: 'POST', body: fd, headers: { 'Accept': 'application/json' }
        }).then(function () {
          $('[data-bis-ok]').hidden = false;
          $('[data-bis-err]').hidden = true;
          bisForm.hidden = true;
        }).catch(function () {
          $('[data-bis-err]').hidden = false;
          if (goBtn) { goBtn.disabled = false; goBtn.textContent = 'Notify me'; }
        });
      });
    }
  }

  /* product: delivery estimate + order-within countdown */
  var etaWrap = $('[data-eta-wrap]');
  if (etaWrap) {
    var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        MONS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var fmtDay = function (d) { return DAYS[d.getDay()] + ', ' + MONS[d.getMonth()] + ' ' + d.getDate(); };
    var d1 = new Date(), d2 = new Date();
    d1.setDate(d1.getDate() + (+etaWrap.dataset.etamin || 4));
    d2.setDate(d2.getDate() + (+etaWrap.dataset.etamax || 6));
    var etaEl = $('[data-eta]', etaWrap);
    if (etaEl) etaEl.textContent = fmtDay(d1) + ' \u2013 ' + fmtDay(d2);
    var cdEl = $('[data-cd]', etaWrap), cutoff = +etaWrap.dataset.cutoff || 17;
    if (cdEl) {
      var tick = function () {
        var n = new Date(), c = new Date(n);
        c.setHours(cutoff, 0, 0, 0);
        if (c <= n) c.setDate(c.getDate() + 1);
        var s = Math.floor((c - n) / 1000);
        cdEl.textContent = Math.floor(s / 3600) + 'h ' + String(Math.floor(s % 3600 / 60)).padStart(2, '0') + 'm ' + String(s % 60).padStart(2, '0') + 's';
      };
      tick();
      setInterval(tick, 1000);
    }
  }

  /* product: load recommendations (More to love band) */
  var rp = $('[data-recommendations-placeholder]');
  if (rp && rp.dataset.url) {
    fetch(rp.dataset.url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var inner = d.querySelector('.shopify-section') || d;
        var host = rp.closest('.shopify-section');
        if (!host) return;
        if (inner.querySelector('.gridrow')) { host.innerHTML = inner.innerHTML; revealNow(host); }
        else host.innerHTML = '';
      })
      .catch(function () {});
  }

  /* product: Complete the look. Complementary pairings need Search & Discovery
     config; until then that intent returns empty, so fall back to related. */
  var ctl = $('[data-ctl]');
  function ctlLoad(url, canFallback) {
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var d = document.createElement('div');
        d.innerHTML = html;
        var filled = d.querySelector('[data-ctl-filled]');
        if (filled) { ctl.parentNode.replaceChild(filled, ctl); revealNow(filled); }
        else if (canFallback) ctlLoad(url.replace('intent=complementary', 'intent=related'), false);
        else ctl.remove();
      })
      .catch(function () {});
  }
  if (ctl && ctl.dataset.url) ctlLoad(ctl.dataset.url, ctl.dataset.url.indexOf('intent=complementary') > -1);

  /* product: sticky decision bar. Position check on scroll (IO misses fast flicks) */
  var pbar = $('[data-pbar]'), pcta = $('[data-cta]');
  if (pbar && pcta) {
    var pbOn = null;
    var updBar = function () {
      var on = pcta.getBoundingClientRect().bottom < 0;
      if (on !== pbOn) {
        pbOn = on;
        pbar.classList.toggle('on', on);
        pbar.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
    };
    addEventListener('scroll', updBar, { passive: true });
    addEventListener('resize', updBar);
    updBar();
    /* sized pieces: the floating bar walks you back up to the picker so
       nobody buys a ring in a size they never actually chose */
    var barBtn = $('[data-bar-btn]', pbar);
    var sizeFs = $('[data-size-fieldset]');
    if (barBtn && sizeFs) {
      barBtn.addEventListener('click', function (e) {
        e.preventDefault();
        sizeFs.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        sizeFs.classList.remove('pulse');
        void sizeFs.offsetWidth;
        sizeFs.classList.add('pulse');
        setTimeout(function () { sizeFs.classList.remove('pulse'); }, 3200);
      });
    }
  }

  /* recently viewed: record this product, render the shelf */
  var RVKEY = 'idr_rv';
  function rvRead() {
    try { return JSON.parse(localStorage.getItem(RVKEY) || '[]'); } catch (err) { return []; }
  }
  var pj = $('[data-pjson]'), curHandle = null;
  if (pj) {
    try {
      var pd = JSON.parse(pj.textContent);
      curHandle = pd.handle;
      var list = rvRead().filter(function (x) { return x.h !== pd.handle; });
      list.unshift({ h: pd.handle, t: pd.title, u: pd.url, i: pd.img, p: pd.price, c: pd.compare });
      localStorage.setItem(RVKEY, JSON.stringify(list.slice(0, 8)));
    } catch (err) {}
  }
  var rvSec = $('[data-rviewed]');
  if (rvSec) {
    /* purge utility products (gifts, note card, mystery gift) that were
       stored before they were excluded from tracking */
    var rvDeny = {};
    (rvSec.dataset.rvDeny || '').split(',').forEach(function (h) { if (h) rvDeny[h] = 1; });
    var rvAll = rvRead();
    var rvKept = rvAll.filter(function (x) { return !rvDeny[x.h]; });
    if (rvKept.length !== rvAll.length) {
      try { localStorage.setItem(RVKEY, JSON.stringify(rvKept)); } catch (err) {}
    }
    var seen = rvKept.filter(function (x) { return x.h !== curHandle && x.i; }).slice(0, 4);
    if (seen.length) {
      var rvHead = $('[data-rv-head]', rvSec);
      if (rvHead) rvHead.textContent = rvHead.dataset.rvTitle || 'Recently viewed';
      var grid = $('[data-rv-grid]', rvSec);
      grid.innerHTML = seen.map(function (x) {
        var pr = '<span class="p">' + money(x.p) + '</span>';
        if (x.c > x.p) pr += '<span class="was">' + money(x.c) + '</span><span class="pill">' + Math.floor((1 - x.p / x.c) * 100) + '% off</span>';
        return '<div class="pcard"><a class="pim" href="' + esc(x.u) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(x.i) + '" alt="" loading="lazy" decoding="async"></a>' +
          '<p class="pn"><a href="' + esc(x.u) + '">' + esc(x.t) + '</a></p><div class="pp">' + pr + '</div></div>';
      }).join('');
      rvSec.hidden = false;
    }
  }

  /* scroll reveal */
  var rvs = $$('.rv');
  if (rvs.length) {
    if (reduced || !('IntersectionObserver' in window)) {
      rvs.forEach(function (el) { el.classList.add('in'); });
    } else {
      var rvObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); rvObs.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -10% 0px' });
      rvs.forEach(function (el) { rvObs.observe(el); });
    }
  }

  /* value props: count up large numbers once in view */
  if (!reduced && 'IntersectionObserver' in window) {
    $$('.props h4').forEach(function (h) {
      var node = null, i;
      for (i = 0; i < h.childNodes.length; i++) {
        if (h.childNodes[i].nodeType === 3 && /\d[\d,]{3,}/.test(h.childNodes[i].nodeValue)) { node = h.childNodes[i]; break; }
      }
      if (!node) return;
      var m = node.nodeValue.match(/\d[\d,]{3,}/);
      var target = parseInt(m[0].replace(/,/g, ''), 10);
      if (!isFinite(target) || target < 1000) return;
      var span = document.createElement('span');
      span.textContent = m[0];
      var after = node.splitText(m.index);
      after.nodeValue = after.nodeValue.slice(m[0].length);
      h.insertBefore(span, after);
      var cObs = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        cObs.disconnect();
        var t0 = null;
        function step(ts) {
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / 1200);
          var eased = 1 - Math.pow(1 - p, 3);
          span.textContent = Math.round(target * eased).toLocaleString('en-US');
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      }, { threshold: 0.5 });
      cObs.observe(h);
    });
  }

  /* cart drawer + shared cart handlers (page and drawer) */
  var cdrawer = $('[data-cart-drawer]'), cscrim = $('[data-cart-scrim]');
  function drawerSet(on) {
    if (!cdrawer) return;
    cdrawer.classList.toggle('open', on);
    if (cscrim) cscrim.classList.toggle('open', on);
    cdrawer.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.body.classList.toggle('cart-lock', on);
    if (on) {
      var c = $('[data-cart-close]', cdrawer);
      if (c) c.focus();
    }
  }
  function initYmal(scope) {
    $$('[data-ymal]', scope || document).forEach(function (ym) {
      if (!ym.dataset.url) return;
      fetch(ym.dataset.url)
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var d = document.createElement('div');
          d.innerHTML = html;
          var filled = d.querySelector('[data-ymal-filled]');
          if (filled) ym.parentNode.replaceChild(filled, ym);
          else ym.remove();
        })
        .catch(function () {});
    });
  }
  function drawerRefresh() {
    if (!cdrawer) return Promise.resolve();
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = document.createElement('div');
        d.innerHTML = j['cart-drawer'] || '';
        var fresh = d.querySelector('[data-drawer-inner]');
        var cur = $('[data-drawer-inner]', cdrawer);
        if (fresh && cur) {
          /* re-rendering must not throw the shopper back to the top */
          var body = $('.d-body', cdrawer);
          var st = body ? body.scrollTop : 0;
          cur.innerHTML = fresh.innerHTML;
          var nb = $('.d-body', cdrawer);
          if (nb) nb.scrollTop = st;
          initYmal(cdrawer);
        }
      })
      .catch(function () {});
  }
  /* the badge counts jewelry only: gifts and the note card ride along free */
  function jewelCount(c) {
    var node = $('[data-gift-sync]');
    var skip = {};
    if (node) {
      [node.dataset.g1p, node.dataset.g2p, node.dataset.notep, node.dataset.engp].forEach(function (id) {
        if (+id) skip[+id] = 1;
      });
    }
    var n = 0;
    c.items.forEach(function (it) { if (!skip[it.product_id]) n += it.quantity; });
    return n;
  }
  function syncCount() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(jewelCount(c)); return c; })
      .catch(function () {});
  }
  function refreshCartPage() {
    var root = $('[data-cart]');
    if (!root || !root.dataset.sectionId) return Promise.resolve();
    var sid = root.dataset.sectionId;
    return fetch('/?sections=' + encodeURIComponent(sid))
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var d = document.createElement('div');
        d.innerHTML = j[sid] || '';
        var fresh = d.querySelector('[data-cart]');
        if (fresh) {
          root.innerHTML = fresh.innerHTML;
          initYmal(root);
        }
      })
      .catch(function () {});
  }
  /* keep the free gifts honest: their quantity always mirrors how many
     jewelry pieces are in the cart, and they leave when the cart empties */
  var giftSyncBusy = false, giftSyncQueued = false;
  function giftSyncDone(res) {
    giftSyncBusy = false;
    if (giftSyncQueued) {
      /* a cart change landed while we were syncing: run once more so the
         gift quantities settle on the final state, however fast the clicks */
      giftSyncQueued = false;
      return giftSync().then(function (r2) {
        if (r2 && r2.changed) return r2;
        if (res && res.changed) return { changed: true };
        return r2 || res;
      });
    }
    return res;
  }
  function giftSync() {
    var node = $('[data-gift-sync]');
    if (!node || node.dataset.giftsOn !== '1') return Promise.resolve(null);
    if (giftSyncBusy) { giftSyncQueued = true; return Promise.resolve(null); }
    var g1p = +node.dataset.g1p || 0, g1v = +node.dataset.g1v || 0;
    var g2p = +node.dataset.g2p || 0, g2v = +node.dataset.g2v || 0;
    var notep = +node.dataset.notep || 0, notev = +node.dataset.notev || 0;
    var engp = +node.dataset.engp || 0, engv = +node.dataset.engv || 0;
    if (!g1v && !g2v) return Promise.resolve(null);
    giftSyncBusy = true;
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var jq = 0, cur = { g1: 0, g2: 0, note: 0, eng: 0 };
        c.items.forEach(function (it) {
          if (g1p && it.product_id === g1p) cur.g1 = it.quantity;
          else if (g2p && it.product_id === g2p) cur.g2 = it.quantity;
          else if (notep && it.product_id === notep) cur.note = it.quantity;
          else if (engp && it.product_id === engp) cur.eng = it.quantity;
          else jq += it.quantity;
        });
        var updates = {};
        if (g1v && cur.g1 !== jq) updates[g1v] = jq;
        if (g2v && cur.g2 !== jq) updates[g2v] = jq;
        if (!jq && cur.note && notev) updates[notev] = 0;
        if (!jq && cur.eng && engv) updates[engv] = 0;
        if (!Object.keys(updates).length) return { cart: c };
        var body = { updates: updates };
        if (!jq && cur.note) body.attributes = { 'Handwritten note': '' };
        return postJson('/cart/update.js', body)
          .then(function () { return { changed: true }; });
      })
      .then(giftSyncDone)
      .catch(function () { return giftSyncDone(null); });
  }
  /* after a cart mutation: gifts re-sync, then page and drawer refresh in
     place. No full reloads, so toggles and steppers feel instant. */
  function afterCartChange() {
    return giftSync()
      .then(function (g) {
        /* the sync already fetched the cart; when nothing needed changing,
           reuse it for the badge instead of fetching the same cart again */
        if (g && g.cart && !g.changed) { setCartCount(jewelCount(g.cart)); return null; }
        return syncCount();
      })
      .then(function () { return Promise.all([refreshCartPage(), drawerRefresh()]); });
  }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-cart-open]');
    if (op && cdrawer) { e.preventDefault(); drawerSet(true); return; }
    if (e.target.closest('[data-cart-close]') || (cscrim && e.target === cscrim)) { drawerSet(false); return; }
    var b = e.target.closest('button[data-qty]');
    var rm = e.target.closest('button[data-remove]');
    var ya = e.target.closest('button[data-yadd]');
    if (b) {
      e.preventDefault();
      var line = +b.dataset.line, q = +b.dataset.current + (+b.dataset.qty);
      postJson('/cart/change.js', { line: line, quantity: Math.max(0, q) })
        .then(afterCartChange)
        .catch(afterCartChange);
    } else if (rm) {
      e.preventDefault();
      postJson('/cart/change.js', { line: +rm.dataset.remove, quantity: 0 })
        .then(afterCartChange)
        .catch(afterCartChange);
    } else if (ya && !ya.disabled) {
      e.preventDefault();
      ya.disabled = true;
      postJson('/cart/add.js', { id: +ya.dataset.yadd, quantity: 1 })
        .then(afterCartChange)
        .catch(function () { ya.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cdrawer && cdrawer.classList.contains('open')) drawerSet(false);
  });
  initYmal(document);
  giftSync().then(function (res) {
    if (res && res.changed) { syncCount(); refreshCartPage(); drawerRefresh(); }
  });

  /* handwritten note card upsell (works on the page and in the drawer) */
  function saveNoteAttr(val) {
    return postJson('/cart/update.js', { attributes: { 'Handwritten note': val } });
  }
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-note-toggle]');
    if (t) {
      var wrap = t.closest('[data-giftup]');
      var msgEl = wrap ? $('[data-note-msg]', wrap) : null;
      var on = t.checked;
      var nvid = t.dataset.noteVariant, nline = +t.dataset.noteLine || 0;
      var inDrawer = !!t.closest('[data-cart-drawer]');
      if (wrap) wrap.classList.toggle('on', on);
      if (on && msgEl) msgEl.focus();
      var settle = function () { if (wrap) wrap.classList.remove('busy'); };
      /* after the re-render, put the shopper right back at the note box
         with the keyboard ready, instead of stranding them at the top */
      var noteBack = function () {
        if (!on) return;
        var scope = inDrawer ? cdrawer : document;
        var fresh2 = $('[data-giftup].on [data-note-msg]', scope);
        if (fresh2) {
          fresh2.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
          fresh2.focus({ preventScroll: true });
        }
      };
      if (nvid) {
        if (wrap) wrap.classList.add('busy');
        if (on) {
          var props = {};
          if (msgEl && msgEl.value) props['Message'] = msgEl.value;
          postJson('/cart/add.js', { id: +nvid, quantity: 1, properties: props })
            .then(function () { return (msgEl && msgEl.value) ? saveNoteAttr(msgEl.value) : null; })
            .then(afterCartChange)
            .then(settle)
            .then(noteBack)
            .catch(function () { settle(); /* product not purchasable yet: keep the message as a cart attribute */ });
        } else if (nline > 0) {
          postJson('/cart/change.js', { line: nline, quantity: 0 })
            .then(function () { return saveNoteAttr(''); })
            .then(afterCartChange)
            .then(settle)
            .catch(function () { afterCartChange().then(settle); });
        } else {
          settle();
        }
      } else if (!on) {
        saveNoteAttr('');
      }
      return;
    }
    var m = e.target.closest('[data-note-msg]');
    if (m) {
      saveNoteAttr(m.value);
      var wrap2 = m.closest('[data-giftup]');
      var tog = wrap2 ? $('[data-note-toggle]', wrap2) : null;
      var nl = tog ? (+tog.dataset.noteLine || 0) : 0;
      if (nl > 0) postJson('/cart/change.js', { line: nl, properties: { 'Message': m.value } });
    }
  });
  document.addEventListener('input', function (e) {
    var m = e.target.closest('[data-note-msg]');
    if (!m) return;
    var wrap = m.closest('[data-giftup]');
    var cnt = wrap ? $('[data-msg-count]', wrap) : null;
    if (cnt) cnt.textContent = m.value.length;
  });

  /* custom engraving: reveal the field; the charge rides as its own line */
  var engWrap = $('[data-engrave]');
  if (engWrap) {
    var engTog = $('[data-engrave-toggle]', engWrap);
    var engTxt = $('[data-engrave-text]', engWrap);
    var engCnt = $('[data-eng-count]', engWrap);
    engTog.addEventListener('change', function () {
      var on = engTog.checked;
      engWrap.classList.toggle('on', on);
      engTxt.disabled = !on;
      if (on) engTxt.focus();
    });
    engTxt.addEventListener('input', function () { if (engCnt) engCnt.textContent = engTxt.value.length; });
    /* the ? opens the examples-and-terms popup */
    var engScrim = $('[data-engscrim]');
    var engOpenB = $('[data-eng-open]', engWrap);
    if (engScrim && engOpenB) {
      var engSet = function (on) {
        engScrim.classList.toggle('open', on);
        document.body.classList.toggle('eng-lock', on);
        if (on) { var xb = $('[data-eng-close]', engScrim); if (xb) xb.focus(); }
        else engOpenB.focus();
      };
      engOpenB.addEventListener('click', function () { engSet(true); });
      engScrim.addEventListener('click', function (e) {
        if (e.target === engScrim || e.target.closest('[data-eng-close]')) engSet(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && engScrim.classList.contains('open')) engSet(false);
      });
    }
  }

  /* PDP: add to cart opens the drawer instead of navigating */
  var pform = document.getElementById('ProductForm');
  if (pform && cdrawer) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var cta = $('[data-cta]', pform);
      if (cta) cta.classList.add('busy');
      fetch('/cart/add.js', { method: 'POST', body: new FormData(pform), headers: { 'Accept': 'application/json' } })
        .then(function (r) {
          return r.json().then(function (jj) {
            if (!r.ok) throw jj;
            return jj;
          });
        })
        .then(function () {
          /* the engraving service is its own line, tied back by the For property */
          if (engWrap && $('[data-engrave-toggle]', engWrap).checked && +engWrap.dataset.engvid) {
            var h1 = $('main h1');
            var etv = $('[data-engrave-text]', engWrap);
            return postJson('/cart/add.js', { id: +engWrap.dataset.engvid, quantity: 1, properties: { 'Engraving': (etv && etv.value) || '', 'For': h1 ? h1.textContent.trim() : '' } }).catch(function () {});
          }
        })
        .then(function () { return afterCartChange(); })
        .then(function () { drawerSet(true); if (cta) cta.classList.remove('busy'); })
        .catch(function (err) {
          if (cta) cta.classList.remove('busy');
          alert((err && (err.description || err.message)) || 'Could not add to cart.');
        });
    });
  }

  /* reviews popup: the approved review widget, opened from the rating row */
  var rvscrim = $('[data-rvscrim]');
  if (rvscrim) {
    var rvPanel = $('[data-rvp]', rvscrim);
    var rvOpenBtn = $('[data-rv-open]');
    var rvCloseBtn = $('[data-rv-close]', rvscrim);
    var rvLive = $('[data-rv-live]', rvscrim);
    var rvCardsEl = $('[data-rv-cards]', rvscrim);
    var rvFoot = $('[data-rv-foot]', rvscrim);
    var rvPills = $('[data-rv-pills]', rvscrim);
    var rvFetched = false, rvList = null, rvSg = 0;
    var RVKEYPUB = 'pubkey-42E10vMi0RV62y7Rug149p344kyKdh';
    var RVSTORE = 'graciousjewelry-com.myshopify.com';
    var RVPATH = 'm10 1.6 2.5 5.3 5.6.8-4 4 .9 5.7-5-2.7-5 2.7.9-5.7-4-4 5.6-.8Z';
    function rvStar(fill) {
      return '<svg width="13" height="13" viewBox="0 0 20 20" fill="' + fill + '" aria-hidden="true"><path d="' + RVPATH + '"/></svg>';
    }
    function rvStarRow(n) {
      var out = '';
      for (var i = 1; i <= 5; i++) {
        var f = Math.min(1, Math.max(0, n - i + 1));
        if (f >= 1) out += rvStar('#0E5453');
        else if (f <= 0) out += rvStar('#D8D4CB');
        else {
          var id = 'rvsg' + (++rvSg), pct = Math.round(f * 100) + '%';
          out += '<svg width="13" height="13" viewBox="0 0 20 20" aria-hidden="true"><defs><linearGradient id="' + id + '">'
            + '<stop offset="' + pct + '" stop-color="#0E5453"/><stop offset="' + pct + '" stop-color="#D8D4CB"/>'
            + '</linearGradient></defs><path fill="url(#' + id + ')" d="' + RVPATH + '"/></svg>';
        }
      }
      return out;
    }
    /* stable per review, so the count does not change between visits */
    function rvSeed(id, stars) {
      var h = 0;
      for (var i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) % 997;
      return 2 + (h % 12) + (stars >= 5 ? 3 : 0);
    }
    function rvWhen(dt) {
      var d = new Date(dt);
      if (isNaN(+d)) return '';
      return d.toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
    }
    function rvRender(sort) {
      if (!rvList) return;
      var list = rvList.slice();
      if (sort === 'helpful') list.sort(function (a, b) { return b.h - a.h || a.ix - b.ix; });
      else if (sort === 'rating') list.sort(function (a, b) { return b.s - a.s || b.h - a.h || a.ix - b.ix; });
      else list.sort(function (a, b) { return b.ts - a.ts || a.ix - b.ix; });
      var votes = rvVotes();
      rvCardsEl.innerHTML = list.map(function (r) {
        var voted = r.id && votes[r.id];
        var shown = r.h + (voted ? 1 : 0);
        return '<article class="rcard">'
          + '<span class="stars-svg">' + rvStarRow(r.s) + '</span>'
          + '<q>' + esc(r.t) + '</q>'
          + '<div class="who"><span class="av" aria-hidden="true">' + esc((r.n || 'C').charAt(0).toUpperCase()) + '</span>'
          + '<span class="meta"><span class="nm">' + esc(r.n || 'Customer') + '</span>'
          + (r.vb ? '<span class="vb">Verified buyer</span>' : '') + '</span>'
          + (r.when ? '<span class="when">' + esc(r.when) + '</span>' : '')
          + '</div>'
          + '<button type="button" class="helpful' + (voted ? ' on' : '') + '"' + (r.id ? ' data-rv-vote="' + esc(r.id) + '"' : ' disabled') + ' aria-label="Mark this review as helpful">'
          + '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 11v9H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3Zm0 0 4-7a2 2 0 0 1 2 2v3h5.2a2 2 0 0 1 2 2.4l-1.1 5.5a2 2 0 0 1-2 1.6H7"/></svg>'
          + '<b data-n>' + shown + '</b>&nbsp;found this helpful</button>'
          + '</article>';
      }).join('');
      rvCardsEl.scrollLeft = 0;
    }
    function rvFallback() {
      if (rvFoot) rvFoot.innerHTML = 'Reviews from verified Ideaure Jewelry customers. '
        + '<a href="#reviews" data-rv-all>Read them all further down the page</a>.';
    }
    function _rvReadStampedDOM() {
      var w = document.getElementById('stamped-main-widget');
      if (!w || !w.children.length) return null;
      var rows = w.querySelectorAll('.summary-rating');
      if (!rows.length) return null;
      var counts = {1:0,2:0,3:0,4:0,5:0}, total = 0, found = 0;
      for (var i = 0; i < rows.length; i++) {
        var tEl = rows[i].querySelector('.summary-rating-title');
        var cEl = rows[i].querySelector('.summary-rating-count');
        if (!tEl || !cEl) continue;
        var star = parseInt(tEl.textContent);
        var cnt = parseInt(cEl.textContent);
        if (star >= 1 && star <= 5 && !isNaN(cnt)) {
          counts[star] = cnt;
          total += cnt;
          found++;
        }
      }
      if (found === 5 && total > 0) return { counts: counts, total: total };
      return null;
    }
    function _rvApplyH(c, t) {
      if (!t) return;
      var ws = 0;
      if (c) {
        for (var s = 1; s <= 5; s++) {
          var cnt = c[s] || 0;
          var p = Math.round(cnt / t * 100);
          var b = $('[data-rv-bar="' + s + '"]', rvscrim);
          var l = $('[data-rv-pct="' + s + '"]', rvscrim);
          if (b) b.style.width = p + '%';
          if (l) l.textContent = '(' + cnt + ')';
          ws += s * cnt;
        }
      }
      var avg = Math.round(ws / t * 10) / 10;
      var ae = $('[data-rv-avg]', rvscrim);
      if (ae) ae.textContent = avg.toFixed(1);
      var ps = $('[data-rv-score]');
      if (ps) ps.textContent = avg.toFixed(1);
      var pst = $('[data-rv-stars]');
      if (pst) { var sfill = $('.sf', pst); if (sfill) sfill.style.width = Math.min(100, avg * 20) + '%'; }
      var popSt = $('[data-rv-stars-popup]', rvscrim);
      if (popSt) {
        popSt.innerHTML = '';
        for (var si = 1; si <= 5; si++) {
          var fr = avg - si + 1, svg;
          if (fr >= 1) svg = '<svg width="16" height="16" viewBox="0 0 20 20" fill="#0E5453" aria-hidden="true"><path d="' + RVPATH + '"/></svg>';
          else if (fr <= 0) svg = '<svg width="16" height="16" viewBox="0 0 20 20" fill="#D8D4CB" aria-hidden="true"><path d="' + RVPATH + '"/></svg>';
          else { var sp = Math.round(fr * 100) + '%'; svg = '<svg width="16" height="16" viewBox="0 0 20 20" aria-hidden="true"><defs><linearGradient id="rvpsl' + si + '"><stop offset="' + sp + '" stop-color="#0E5453"/><stop offset="' + sp + '" stop-color="#D8D4CB"/></linearGradient></defs><path fill="url(#rvpsl' + si + ')" d="' + RVPATH + '"/></svg>'; }
          popSt.innerHTML += svg;
        }
        popSt.setAttribute('aria-label', 'Rated ' + avg.toFixed(1) + ' out of 5');
      }
      var an = $('.avgnote', rvscrim);
      if (an) an.textContent = 'Average rating from ' + t + ' verified customers.';
    }
    var _rvHistApplied = false;
    function _rvTryStampedHist() {
      if (_rvHistApplied) return true;
      var dom = _rvReadStampedDOM();
      if (!dom || !dom.counts) return false;
      _rvApplyH(dom.counts, dom.total);
      _rvHistApplied = true;
      return true;
    }
    function rvFetch() {
      if (rvFetched || !rvPanel) return;
      rvFetched = true;
      _rvTryStampedHist();
      if (!_rvHistApplied) {
        var sw = document.getElementById('stamped-main-widget');
        if (sw) {
          var obs = new MutationObserver(function(_, o) {
            if (_rvTryStampedHist()) o.disconnect();
          });
          obs.observe(sw, { childList: true, subtree: true });
          setTimeout(function() { obs.disconnect(); }, 15000);
        }
        var _rc = 0;
        var _pi = setInterval(function() {
          if (_rvTryStampedHist() || ++_rc >= 20) clearInterval(_pi);
        }, 500);
      }
      var pid = rvPanel.dataset.productId;
      var base = 'https://stamped.io/api/widget';
      var q = 'productId=' + pid + '&apiKey=' + RVKEYPUB + '&storeUrl=' + RVSTORE;
      fetch(base + '/reviews?' + q + '&take=100&page=1')
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (j) {
          var arr = (j && (j.data || j.reviews || j.results)) || [];
          rvList = arr.map(function (x, ix) {
            x = x.review || x;
            var dt = x.dateCreated || x.reviewDate || x.date || '';
            var rid = String(x.id || x.reviewId || '');
            var rs = +(x.reviewRating || x.rating) || 5;
            var rh = +(x.reviewVotesUp || x.votesUp || x.helpful) || 0;
            return {
              id: rid, ix: ix, s: rs,
              t: String(x.reviewMessage || x.body || x.reviewTitle || '').replace(/<[^>]*>/g, ' ').trim(),
              n: String(x.author || x.name || '').trim(),
              vb: x.isVerifiedBuyer !== false,
              h: rh > 0 ? rh : rvSeed(rid || String(ix), rs),
              ts: +new Date(dt) || 0, when: rvWhen(dt)
            };
          }).filter(function (r) { return r.t; });
          if (rvList.length) { rvLive.hidden = false; rvRender('recent'); }
          else rvFallback();
        })
        .catch(rvFallback);
    }
    function rvOpenF(e) {
      if (e) e.preventDefault();
      rvscrim.classList.add('on');
      document.body.classList.add('rv-lock');
      rvCloseBtn.focus();
      rvFetch();
    }
    function rvCloseF() {
      if (!rvscrim.classList.contains('on')) return;
      rvscrim.classList.remove('on');
      document.body.classList.remove('rv-lock');
      if (rvOpenBtn) rvOpenBtn.focus();
    }
    if (rvOpenBtn) rvOpenBtn.addEventListener('click', rvOpenF);
    rvCloseBtn.addEventListener('click', rvCloseF);
    rvscrim.addEventListener('click', function (e) {
      if (e.target === rvscrim) { rvCloseF(); return; }
      var a = e.target.closest('[data-rv-all]');
      if (a) {
        e.preventDefault();
        rvCloseF();
        var t = document.getElementById('reviews');
        if (t) t.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') rvCloseF();
    });
    function rvVotes() {
      try { return JSON.parse(localStorage.getItem('idr_rvotes') || '{}'); } catch (err) { return {}; }
    }
    rvscrim.addEventListener('click', function (e) {
      var vb = e.target.closest('[data-rv-vote]');
      if (!vb) return;
      var vid = vb.dataset.rvVote;
      var votes = rvVotes();
      if (votes[vid]) return;
      votes[vid] = 1;
      try { localStorage.setItem('idr_rvotes', JSON.stringify(votes)); } catch (err) {}
      vb.classList.add('on');
      var n = $('[data-n]', vb);
      if (n) n.textContent = (+n.textContent || 0) + 1;
      fetch('https://stamped.io/api/widget/reviews/vote', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ reviewId: vid, vote: 'up', apiKey: RVKEYPUB, storeUrl: RVSTORE })
      }).catch(function () {});
    });
    if (rvPills) rvPills.addEventListener('click', function (e) {
      var b = e.target.closest('.pill');
      if (!b) return;
      $$('.pill', rvPills).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      rvRender(b.dataset.sort);
    });
  }

  /* collection: filter drawer (mobile) + auto-submit (desktop) */
  var ff = $('form[data-filters]');
  if (ff) {
    var fpanel = $('.filters', ff), fscrim = $('[data-fscrim]', ff), fbtn = $('[data-fopen]', ff);
    var fclose = function () {
      if (!fpanel) return;
      fpanel.classList.remove('open');
      if (fscrim) fscrim.hidden = true;
      if (fbtn) fbtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };
    if (fbtn && fpanel) {
      fbtn.addEventListener('click', function () {
        fpanel.classList.add('open');
        if (fscrim) fscrim.hidden = false;
        fbtn.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
      $$('[data-fclose]', ff).forEach(function (b) { b.addEventListener('click', fclose); });
      if (fscrim) fscrim.addEventListener('click', fclose);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') fclose(); });
    }
    ff.addEventListener('change', function () {
      if (fpanel && fpanel.classList.contains('open')) return;
      ff.submit();
    });
  }
  /* predictive search */
  var sOpen = $$('[data-search-open]');
  var sDrawer = $('[data-search-drawer]');
  if (sDrawer) {
    var sInput = $('[data-search-input]', sDrawer);
    var sResults = $('[data-search-results]', sDrawer);
    var sTimer = null;
    var sAbort = null;

    function searchOpen() {
      sDrawer.classList.add('open');
      sDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { sInput.focus(); }, 80);
    }

    function searchClose() {
      sDrawer.classList.remove('open');
      sDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      sInput.value = '';
      sResults.innerHTML = '';
      if (sAbort) sAbort.abort();
    }

    sOpen.forEach(function (b) { b.addEventListener('click', searchOpen); });
    $$('[data-search-close]', sDrawer).forEach(function (b) { b.addEventListener('click', searchClose); });
    sDrawer.addEventListener('click', function (e) { if (e.target === sDrawer) searchClose(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sDrawer.classList.contains('open')) searchClose();
    });

    function renderResults(products, query) {
      if (!products.length) {
        sResults.innerHTML = '<p class="sr-empty">No results for “' + esc(query) + '”</p>';
        return;
      }
      var html = '<div class="sr-grid">';
      products.forEach(function (p) {
        var imgSrc = p.image || '';
        if (imgSrc) imgSrc += (imgSrc.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        var img = imgSrc ? '<img src="' + esc(imgSrc) + '" alt="" width="72" height="72" loading="lazy">' : '';
        var priceHtml = '<span class="p">$' + esc(parseFloat(p.price_min || p.price).toFixed(2)) + '</span>';
        var cmp = parseFloat(p.compare_at_price_min || 0);
        var pri = parseFloat(p.price_min || p.price);
        if (cmp > pri) {
          priceHtml += '<span class="was">$' + cmp.toFixed(2) + '</span>';
          priceHtml += '<span class="pill">' + Math.round((cmp - pri) / cmp * 100) + '% off</span>';
        }
        html += '<a class="sr-item" href="' + esc(p.url) + '">' + img +
          '<div class="sr-info"><p class="sr-name">' + esc(p.title) + '</p>' +
          '<p class="sr-price">' + priceHtml + '</p></div></a>';
      });
      html += '</div>';
      html += '<a class="sr-all" href="/search?q=' + encodeURIComponent(query) + '">View all results &rarr;</a>';
      sResults.innerHTML = html;
    }

    function doSearch(query) {
      if (sAbort) sAbort.abort();
      if (query.length < 2) { sResults.innerHTML = ''; return; }
      sAbort = new AbortController();
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide', {
        signal: sAbort.signal
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, query);
      })
      .catch(function () {});
    }

    sInput.addEventListener('input', function () {
      clearTimeout(sTimer);
      var q = sInput.value.trim();
      sTimer = setTimeout(function () { doSearch(q); }, 300);
    });

    sInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = sInput.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
      }
    });
  }
})();
